import axiosInstance from "../../axios/axiosUmbraco";
const umbracoStreamingId = process.env.REACT_APP_UMBRACO_LIVE_STREAM_ID;

export function checkLiveEventubraco() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`umbraco/delivery/api/v1/content/item/${umbracoStreamingId}`).then(response => {
            if (response.status == 200) {
                const formattedData = {
                    streamingUrl: response?.data?.properties.streamingUrl,
                    streamingName: response?.data?.properties?.streamingName,
                    isActive: response?.data?.properties?.isActive,

                }
                resolve(formattedData ?? {});
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}